import React from 'react'
import SessionsList from '../components/SessionsList/SessionsList'

export default function Purchases() {
  return (
    <SessionsList />
  )
}
